"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./Pagination.style"));

var BulletPagination_1 = tslib_1.__importDefault(require("./BulletPagination"));

var DynamicBulletPagination_1 = tslib_1.__importDefault(require("./DynamicBulletPagination"));

var FractionPagination_1 = tslib_1.__importDefault(require("./FractionPagination"));

var Swiper_1 = require("./Swiper");

function Pagination(_a) {
  var isNotSingleSlide = _a.isNotSingleSlide,
      paginationType = _a.paginationType,
      paginationProps = tslib_1.__rest(_a, ["isNotSingleSlide", "paginationType"]);

  if (!isNotSingleSlide) {
    return null;
  }

  switch (paginationType) {
    case Swiper_1.PaginationEnum.FRACTION:
      return jsx_runtime_1.jsx(FractionPagination_1.default, Object.assign({}, paginationProps), void 0);

    case Swiper_1.PaginationEnum.BULLETS:
      return jsx_runtime_1.jsx(react_1.Fragment, {
        children: jsx_runtime_1.jsx(BulletPagination_1.default, Object.assign({}, paginationProps), void 0)
      }, void 0);

    case Swiper_1.PaginationEnum.DYNAMICBULLETS:
      return jsx_runtime_1.jsxs(react_1.Fragment, {
        children: [jsx_runtime_1.jsx("div", {
          className: "bullet-gradation",
          css: styles.bulleGradation
        }, void 0), jsx_runtime_1.jsx(DynamicBulletPagination_1.default, Object.assign({}, paginationProps), void 0)]
      }, void 0);

    default:
      return null;
  }
}

exports.default = Pagination;